import { action } from 'satcheljs';
export var fileProvidersLoaded = action('fileProvidersLoaded', function (fileProviders) { return ({
    fileProviders: fileProviders,
}); });
//# sourceMappingURL=fileProvidersLoaded.js.map